var _defs, _g, _path, _g2, _path2, _path3, _path4, _path5, _g3, _path6, _g4, _path7, _path8, _path9, _path10, _path11, _g5, _g6, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlockchainIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "id1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 276 214 L 305.484375 214 L 305.484375 262 L 276 262 Z M 276 214 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.234375 214 L 99 214 L 99 262 L 69.234375 262 Z M 69.234375 214 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.234375 128 L 99 128 L 99 176 L 69.234375 176 Z M 69.234375 128 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 276 128 L 305.484375 128 L 305.484375 176 L 276 176 Z M 276 128 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 190 257 L 219.574219 257 L 219.574219 304.734375 L 190 304.734375 Z M 190 257 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 155.140625 257 L 185 257 L 185 304.734375 L 155.140625 304.734375 Z M 155.140625 257 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 276.476562 261.570312 L 305.484375 249.972656 L 305.484375 214.484375 L 276.476562 226.105469 L 276.476562 261.570312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 276.476562 181.199219 L 274.734375 181.890625 C 274.125 182.101562 273.457031 182.101562 272.847656 181.890625 L 271.105469 181.199219 L 271.105469 200.539062 L 246.777344 210.269531 L 273.875 221.09375 L 300.972656 210.269531 L 276.644531 200.539062 L 276.644531 181.199219 L 276.476562 181.199219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 69.234375 249.929688 L 98.238281 261.550781 L 98.238281 226.0625 L 69.234375 214.464844 L 69.234375 249.929688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 103.777344 181.199219 L 102.035156 181.890625 C 101.429688 182.101562 100.757812 182.101562 100.148438 181.890625 L 98.40625 181.199219 L 98.40625 200.539062 L 73.910156 210.375 L 101.007812 221.09375 L 128.105469 210.269531 L 103.777344 200.644531 L 103.777344 181.199219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 241.933594 163.625 L 270.9375 175.222656 L 270.9375 139.753906 L 256.425781 133.945312 L 241.933594 128.136719 L 241.933594 135.980469 L 236.414062 131.367188 L 224.671875 121.59375 L 219.132812 116.976562 L 219.132812 84.949219 L 190.125 96.550781 L 190.125 132.039062 L 216.09375 121.65625 L 220.9375 125.683594 L 236.414062 138.558594 L 241.933594 143.175781 L 241.933594 163.625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 214.457031 80.859375 L 187.359375 70.039062 L 160.257812 80.859375 L 187.359375 91.703125 L 214.457031 80.859375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 153.777344 125.683594 L 158.625 121.65625 L 184.589844 132.039062 L 184.589844 96.550781 L 155.582031 84.949219 L 155.582031 116.976562 L 150.046875 121.59375 L 138.320312 131.367188 L 132.785156 135.980469 L 132.785156 128.136719 L 103.777344 139.753906 L 103.777344 175.222656 L 132.785156 163.625 L 132.785156 143.175781 L 138.320312 138.558594 L 153.777344 125.683594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 98.238281 139.753906 L 69.234375 128.136719 L 69.234375 163.625 L 98.238281 175.222656 L 98.238281 139.753906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 73.910156 124.046875 L 101.007812 134.890625 L 128.105469 124.046875 L 101.007812 113.222656 L 73.910156 124.046875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 305.484375 128.136719 L 290.96875 133.945312 L 276.476562 139.753906 L 276.476562 175.222656 L 305.484375 163.625 L 305.484375 128.136719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 300.828125 124.046875 L 273.707031 113.222656 L 246.589844 124.046875 L 273.707031 134.890625 L 300.828125 124.046875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 190.398438 190.972656 C 189.246094 192.167969 187.882812 193.09375 186.371094 193.742188 C 186.394531 194.203125 186.476562 194.664062 186.601562 195.125 C 186.601562 195.125 186.601562 195.378906 186.601562 195.503906 C 186.730469 195.839844 186.855469 196.15625 187.023438 196.449219 L 187.253906 196.804688 C 187.484375 197.222656 187.777344 197.601562 188.113281 197.9375 L 189.707031 199.511719 C 191.679688 198.585938 193.480469 197.328125 195.011719 195.820312 C 196.941406 193.867188 198.433594 191.519531 199.355469 188.917969 C 200.71875 184.976562 200.71875 180.695312 199.355469 176.753906 C 199.167969 176.1875 198.933594 175.640625 198.703125 175.097656 C 197.804688 173.019531 196.503906 171.152344 194.910156 169.558594 L 179.074219 153.261719 C 175.613281 149.71875 170.871094 147.726562 165.945312 147.726562 C 155.6875 147.535156 147.214844 155.675781 147.023438 165.929688 C 146.921875 171.089844 148.976562 176.0625 152.6875 179.648438 L 168.734375 195.734375 C 168.753906 195.523438 168.753906 195.292969 168.734375 195.085938 C 168.734375 194.707031 168.734375 194.351562 168.734375 193.953125 C 168.734375 193.574219 168.734375 193.21875 168.734375 192.863281 C 168.734375 192.503906 168.734375 192.105469 168.734375 191.75 C 168.734375 191.394531 168.734375 190.972656 168.734375 190.597656 C 168.734375 190.199219 168.734375 189.902344 168.878906 189.546875 C 169.003906 189.171875 168.878906 188.730469 169.089844 188.351562 C 169.320312 187.953125 169.089844 187.679688 169.320312 187.367188 L 169.320312 187.050781 L 157.175781 174.949219 C 152.542969 170.292969 152.542969 162.742188 157.199219 158.085938 C 161.855469 153.453125 169.382812 153.453125 174.039062 158.085938 L 190.398438 174.109375 C 195.035156 178.746094 195.054688 186.277344 190.421875 190.910156 C 190.421875 190.933594 190.398438 190.933594 190.398438 190.953125 L 190.398438 190.972656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 227.480469 209.492188 C 227.480469 204.542969 225.488281 199.824219 221.964844 196.363281 L 205.898438 180.277344 C 206.152344 183.191406 205.898438 186.128906 205.121094 188.960938 L 217.265625 201.0625 C 221.902344 205.71875 221.902344 213.269531 217.246094 217.925781 C 212.589844 222.558594 205.039062 222.558594 200.402344 217.925781 L 184.316406 201.753906 C 179.679688 197.121094 179.660156 189.589844 184.296875 184.953125 C 184.296875 184.933594 184.316406 184.933594 184.316406 184.914062 C 185.46875 183.738281 186.832031 182.792969 188.34375 182.164062 C 188.28125 180.589844 187.609375 179.082031 186.496094 177.96875 L 184.902344 176.375 C 175.675781 180.65625 171.605469 191.539062 175.78125 200.8125 C 176.703125 202.867188 177.984375 204.753906 179.597656 206.328125 L 195.789062 222.496094 C 199.25 226.042969 203.96875 228.035156 208.917969 228.035156 C 219.15625 228.015625 227.460938 219.707031 227.480469 209.453125 L 227.480469 209.492188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 224.671875 262.621094 L 224.671875 269.835938 L 241.511719 255.761719 L 246.359375 251.734375 L 270.9375 261.570312 L 270.9375 226.105469 L 241.933594 214.484375 L 241.933594 248.234375 L 236.542969 252.699219 L 224.671875 262.621094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 103.777344 226.0625 L 103.777344 261.550781 L 128.335938 251.734375 L 133.160156 255.742188 L 150.046875 269.835938 L 150.046875 262.621094 L 138.152344 252.699219 L 132.785156 248.234375 L 132.785156 214.464844 L 103.777344 226.0625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 190.125 304.734375 L 219.132812 293.136719 L 219.132812 257.648438 L 190.125 269.25 L 190.125 304.734375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 155.582031 293.136719 L 184.589844 304.734375 L 184.589844 269.25 L 155.582031 257.648438 L 155.582031 293.136719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 160.257812 253.558594 L 187.359375 264.382812 L 214.457031 253.558594 L 187.359375 242.738281 L 160.257812 253.558594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockchainIcon);
export default __webpack_public_path__ + "static/media/blockchain_icon.9eda42a7d99882cc664ebf9384fcdbd2.svg";
export { ForwardRef as ReactComponent };